import type { LyricsReport } from "~/types";

const PREFIX = "Mai jos este o lista de probleme semnalate de utilizatori pentru versuri. Treci prin fiecare item si actualizeaza versurile corespunzator. Daca problema se refera ca slug trebuie schimbat asta inseamna ca fisierul trebuie redenumit. Campul slug nu trebuie sa existe in JSON - el se refera la numele fisierului. ATENȚIE: când modifici versurile actualizează și câmpul `lastUpdatedAt` din JSON la data curentă (format ISO). Dupa fiecare modificare ai grija ca fisierul este in continuare un JSON valid (foloseste in frontend comanda `bun run lyrics:json:test`). Editeaza fiecare item unul cate unul, nu aplica scripturi de batch editing.\n\n";

const SUFFIX = `
VERY IMPORTANT!!

DO NOT RUN ANY BATCH EDITING SCRIPT.

GO THROUGH EACH ITEM ONE BY ONE AND DELEGATE TO A SUBAGENT.

KEEP TRACK OF EACH AND EVERY ITEM YOU GO THROUGH.

ONCE THE SUBAGENT CONFIRMS THE CHANGE CROSS IT OUT AND GO TO THE NEXT. USE A FILE FOR MEMORY TO KEEP TRACK OF THINGS.

DO NOT CHANGE ONLY THE TIMESTAMP IN THE LYRICS, IF THERE IS NO CHANGE DONE THEN THE TIMESTAMP SHOULD NOT BE UPDATED. UPDATE THE TIMESTAMP ONLY IF THERE IS A CHANGE IN THE LYRICS.

DO NOT CHANGE THE SOURCE URL! THIS IS READONLY FIELD!

DONT STOP UNTIL EVERYTHING I ASKED IS DONE TO THE LETTER.
`

export function reportToClipboard(
  reportOrReports: LyricsReport | LyricsReport[],
  separator = "\n\n---\n\n",
  prefix = PREFIX,
  suffix = SUFFIX
): string {
  if (Array.isArray(reportOrReports)) {
    return prefix + reportOrReports.map((r) => reportToClipboard(r, "", "", "")).join(separator) + suffix;
  }

  const report = reportOrReports;
  const rawSlug = report.url
    ? report.url.split("/").filter(Boolean).pop()
    : null;
  const cleanedSlug = rawSlug
    ? rawSlug.split("?")[0].split("#")[0]
    : null;
  const slug = cleanedSlug || report.url || "";

  const text = [
    `Problema #${report.id}: ${report.category}`,
    `Fisier: ${slug}.json`,
    report.description ? `${report.description}` : null,
  ]
    .filter(Boolean)
    .join("\n");

  return prefix + text + suffix;
}